import { find } from 'lodash';
import { LocalDataSource } from 'ng2-smart-table';
import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { CheckListOptionsConfigService } from './shared/check-list-options.config.service';
import { Logger } from '@app/core';
import { OpcionesListaChequeo, BaseControl, ConfirmComponent } from '@app/shared';
import { CheckListOptionsFormsService } from './shared/check-list-options.form.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

const log = new Logger('CondictionsDocumentsComponent');

@Component({
  selector: 'iw-check-list-options',
  templateUrl: './check-list-options.component.html',
  styleUrls: ['./check-list-options.component.scss'],
  providers: [CheckListOptionsFormsService]
})
export class CheckListOptionsComponent implements OnInit, OnDestroy {

  // Opciones configuradas de la lista de chequeo
  @Input() options: OpcionesListaChequeo[] = [];
  // Mensaje de la accion a realizar en el formulario de condicion
  actionForm = '';
  // Contiene el la posicion en el array de la opcion seleccionada
  indexOptionSelected = -1;
  // Define cuando se muestra el formulario para agregar o modificar la opcion
  form = false;
  // Define cuando se realiza la accion de modificar
  updated = false;
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Configuracion de la tabla
  settings = {};
  // Contiene los controles de el formulario de opciones
  controls: BaseControl<any>[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;

  constructor(
    private clofs: CheckListOptionsFormsService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    const configTable = new CheckListOptionsConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      log.debug(res.action, res.data);
      this.defineAction(res.action, res.data);
    });
    this.loadingOptions();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Setea las opciones
   *
   * @param {OpcionesListaChequeo[]} options
   * @memberof CheckListOptionsComponent
   */
  setListOptions(options: OpcionesListaChequeo[]) {
    this.options = options;
    this.loadingOptions();
  }

  /**
   * Retorna las opciones
   *
   * @returns {OpcionesListaChequeo[]}
   * @memberof CheckListOptionsComponent
   */
  getListOptions(): OpcionesListaChequeo[] {
    return this.options;
  }

  /**
   * Carga las opciones configuradas en la tabla
   *
   * @memberof CheckListOptionsComponent
   */
  protected loadingOptions() {
    if (this.options && this.options.length) {
      this.options.map((option, i) => {
        option.index = i;
        if (option.por_defecto) {
          option['defecto'] = 'Sí';
        } else {
          option['defecto'] = 'No';
        }
      });
    }
    this.sourceData = new LocalDataSource(this.options);
    this.sourceData.refresh();
  }

  /**
   * Controla las acciones sobre la tabla y sus registros
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {OpcionesListaChequeo} [data]
   * @memberof CheckListOptionsComponent
   */
  defineAction(action: 'add' | 'update' | 'delete' = 'add', data?: OpcionesListaChequeo) {
    switch (action) {
      case 'update':
        this.controls = this.clofs.getForm(data);
        this.form = true;
        this.indexOptionSelected = data.index;
        this.updated = true;
        break;
      case 'delete':
          this.updated = false;
        this.confirm.new({
          question: '¿Realmente desea eliminar la opción?',
          labelConfirm: 'Sí',
          labelDecline: 'No'
        }).then(resp => {
          if (resp) {
            this.options.splice(data.index, 1);
            this.loadingOptions();
          }
        });
        break;

      default:
        this.controls = this.clofs.getForm();
        this.form = true;
        this.updated = false;
        break;
    }
  }

  /**
   * Cerrar formulario de opciones
   *
   * @memberof CheckListOptionsComponent
   */
  closeForm() {
    this.form = false;
    this.controls = [];
    this.indexOptionSelected = -1;
    this.updated = false;
  }

  /**
   * Guarda o modifica la opcion ingresada en el formulario
   *
   * @param {*} data
   * @memberof CheckListOptionsComponent
   */
  sended(data: any) {
    let valid = true;
    if (data.chkPorDefecto) {
      const existDefault = find(this.options, {por_defecto: true});
      if (existDefault && existDefault.index !== this.indexOptionSelected) {
        valid = false;
      }
    }
    if (valid) {
      const option: OpcionesListaChequeo = {
        label: data.txtLabelOpcion,
        valor: data.txtValorOpcion,
        por_defecto: data.chkPorDefecto
      };
      if (this.updated) {
        this.options[this.indexOptionSelected] = option;
      } else {
        this.options.push(option);
      }
      this.loadingOptions();
      this.closeForm();
    } else {
      this.toastr.warning('Ya existe una opción por defecto configurada.', 'Información incorrecta.');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/check-list/check-list-options/check-list-options.component.ts